import { BROWSER_SESSION, BUILDER_SESSION, type SessionType } from '~/types'

export const useBrandingOptions = () => {
  const route = useRoute()
  const { sessionData: browserSessionData } = storeToRefs(useBrowserSessionStore())
  const { sessionData: builderSessionData } = storeToRefs(useBuilderSessionStore())

  const sessionType = computed<SessionType | undefined>(() => {
    const routeSessionType = 'type' in route.params && typeof route.params.type === 'string'
      ? route.params.type
      : undefined

    if (route.meta.auth === BUILDER_SESSION)
      return BUILDER_SESSION

    if (route.meta.auth === BROWSER_SESSION)
      return BROWSER_SESSION

    if (routeSessionType === BUILDER_SESSION)
      return BUILDER_SESSION

    if (routeSessionType === BROWSER_SESSION)
      return BROWSER_SESSION

    return undefined
  })

  const sessionData = computed(() => {
    if (sessionType.value === BUILDER_SESSION)
      return builderSessionData.value

    if (sessionType.value === BROWSER_SESSION)
      return browserSessionData.value
  })

  const brandingOptions = computed(() => sessionData.value?.branding_options)

  // Keep favicon links out of the initial head until branding is known.
  // Safari may keep using an early generic favicon even after the SPA updates it.
  const isBrandingLoaded = computed(() => !!sessionData.value)

  return {
    brandingOptions,
    isBrandingLoaded,
  }
}
